var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center my-6 mt-8 content-start"},[_c('h1',{staticClass:"text-white font-bold text-3xl flex-no-shrink"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }